module.exports = __webpack_public_path__ + "static/media/home-background.8150a95d.svg";